ko.bindingHandlers.date = {
  format: ko.observable('DD.MM.YYYY'),
  update: function(element, valueAccessor, allBindingsAccessor) {
    return ko.bindingHandlers.text.update(element, function() {
      var format, value;
      value = ko.utils.unwrapObservable(valueAccessor()) || '0000-00-00';
      format = ko.utils.unwrapObservable(allBindingsAccessor().format !== void 0 ? allBindingsAccessor().format : ko.bindingHandlers.date.format);
      return moment(value, 'YYYY-M-D HH:mm', 'de').format(format);
    });
  }
};

ko.bindingHandlers.dateDiff = {
  format: ko.observable('DD.MM.YYYY'),
  update: function(element, valueAccessor, allBindingsAccessor) {
    return ko.bindingHandlers.text.update(element, function() {
      var format, value;
      value = ko.utils.unwrapObservable(valueAccessor()) || '0000-00-00';
      format = ko.utils.unwrapObservable(allBindingsAccessor().format !== void 0 ? allBindingsAccessor().format : ko.bindingHandlers.date.format);
      return moment(value).fromNow();
    });
  }
};

//# sourceMappingURL=bindings.js.map
